<template>
  <div class="k12-gl-gslb-3nf1-1-01">
    <div class="k12-gl-gslb-3nf1-1-01-left" v-viewer>
      <dl v-for="(item, index) in list" :key="index">
        <dt>
          <img :alt="item.title" :src="item.article_img" :title="item.title" />
        </dt>
        <dd>{{ item.title }}</dd>
      </dl>
    </div>
    <div class="clear"></div>
    <div class="fenye">
      <pagination
        :total="total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
        layout="total, prev, pager, next, jumper"
        :page-sizes="[12, 24, 36]"
        :hide-on-single-page="total < listQuery.limit"
        @pagination="getList"
      />
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/common/pagination";
export default {
  data() {
    return {
      total: 0,
      list: [],
      listQuery: {
        page: 1,
        limit: 12
      }
    };
  },
  components: {
    Pagination
  },
  mounted() {
    this.getList(this.$route.meta.typeid);
  },
  watch: {
    $route: {
      handler: function(val, oldVal) {
        this.getList(this.$route.meta.typeid);
        // this.getSeo()
      },
      // 深度观察监听
      deep: true
    }
  },
  methods: {
    getList(classifyidd) {
      this.$post("/Article/article_list", {
        classifyid: this.$route.meta.typeid,
        page: this.listQuery.page,
        limit: this.listQuery.limit
      }).then(response => {
        // console.log(response);
        this.total = response.count;
        this.list = response.data || [];
      });
    }
  }
};
</script>

<style lang="less">
.k12-gl-gslb-3nf1-1-01-left {
  dl {
    width: 24%;
    float: left;
    background: #f0f0f0;
    margin: 0 1.3% 13px 0;
    &:nth-child(4n) {
      margin-right: 0;
    }
  }
  dt {
    border: solid 1px rgba(236, 236, 236, 1);
    padding: 10px 9px;
    background: #fff;
    height: 200px;
    overflow: hidden;

    img {
      margin: 0 auto;
      display: block;
      max-width: 100%;
      max-height: 100%;
    }
  }
  dd {
    height: 50px;
    font-size: 14px;
    line-height: 50px;
    text-align: center;
    padding: 0 5px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    background: #f0f0f0;
    background-color: rgba(240, 240, 240, 1);
    a {
      color: rgba(51, 51, 51, 1);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/case/list.vue